<template>
  <v-container>
    <h1 class="text-center">{{ title }}</h1>
    <v-row class="mb-2">
      <v-col cols="12" sm="6">
        <v-btn color="success" block @click="pickWinner">
          Gewinner ziehen!
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6">
        <v-btn color="success" block @click="lastWinner">
          Letzter Gewinner!
        </v-btn>
      </v-col>
    </v-row>
    <v-toolbar flat>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-toolbar>

    <!-- Desktop: Data Table -->
    <v-data-table
      v-if="!$vuetify.breakpoint.smAndDown"
      :search="search"
      :headers="headers"
      :items="giveaways"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top color="error">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              :disabled="item.started ==! null && item.stopped === null"
              @click="deleteItem(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Löschen!</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.tstamp`]="{ item }">
        <div v-if="item.tstamp">
          {{ new Date(item.tstamp * 1000).toLocaleString('de-De') }}
        </div>
        <i v-else>-</i>
      </template>
      <template v-slot:[`item.confirm_buyin`]="{ item }">
        <div>{{ item.confirm_buyin === 1 ? 'Ja' : 'Nein' }}</div>
      </template>
    </v-data-table>

    <!-- Mobile: Card List -->
    <template v-else>
      <v-card
        v-for="item in mobileItems"
        :key="item.pos"
        class="mb-3"
        outlined
      >
        <v-card-title class="d-flex justify-space-between align-center py-2">
          <span class="subtitle-1 font-weight-bold">{{ item.username }}</span>
          <v-chip small class="ml-2">#{{ item.pos }}</v-chip>
        </v-card-title>
        <v-card-text class="pt-0 pb-2">
          <div class="caption grey--text">
            <span v-if="item.tstamp">
              {{ new Date(item.tstamp * 1000).toLocaleString('de-De') }}
            </span>
            <i v-else>-</i>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            icon
            :disabled="item.started ==! null && item.stopped === null"
            @click="deleteItem(item)"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-alert v-if="mobileItems.length === 0" type="info" class="mt-2">
        Keine Teilnehmer gefunden.
      </v-alert>
    </template>

    <!-- Shared Dialogs -->
    <v-dialog v-model="dialog" max-width="80vw">
      <v-card>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.title"
                    label="Titel"
                    :rules="[v => !!v || 'Titel is required']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-checkbox v-model="editedItem.confirm_buyin" label="Kauf bestätigung" />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save" :loading="saving">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">
          Sicher diesen User aus dem Giveaway löschen?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Nein!</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">Ja!</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogWinner" max-width="500px">
      <v-card class="text-center">
        <v-card-title class="text-h5 justify-center">
          Der Gewinner dieses Giveaways ist:<br>{{ winner }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="pickWinner(safeWinnerItem)">Reroll!</v-btn>
          <v-btn color="blue darken-1" text @click="closeGiveawayWinnerDialog">Verstanden!</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogWatchWinner" max-width="500px">
      <v-card class="text-center">
        <v-card-title class="text-h5 justify-center">
          Der Gewinner dieses Giveaways war:<br>{{ winner }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeGiveawayWatchWinnerDialog">Verstanden!</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import BackendService from '@/services/BackendService';

export default {
  name: 'giveawayNoPointsEntrant',

  data: () => ({
    title: '',
    safeWinnerItem: {},
    winner: '',
    search: '',
    dialog: false,
    dialogDelete: false,
    dialogWinner: false,
    dialogWatchWinner: false,
    saving: false,
    giveaways: [],
    valid: true,
    intervalId: '',
    headers: [
      { text: 'Position', value: 'pos', align: 'center' },
      { text: 'Username', value: 'username', align: 'center' },
      { text: 'Beigetreten', value: 'tstamp', align: 'center' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
  }),

  computed: {
    mobileItems() {
      if (!this.search) return this.giveaways;
      const s = this.search.toLowerCase();
      return this.giveaways.filter((g) => g.username && g.username.toLowerCase().includes(s));
    },
  },

  mounted() {
    BackendService.loadGiveawayNoPointsEntrant({
      id: this.$route.params.id,
    }).then((data1) => {
      this.title = data1.data[0].title;
      this.giveaways = data1.data;
    });
    this.intervalId = setInterval(() => {
      BackendService.loadGiveawayNoPointsEntrant({
        id: this.$route.params.id,
      }).then((data1) => {
        this.title = data1.data[0].title;
        this.giveaways = data1.data;
      });
    }, 10000);
  },

  beforeDestroy() {
    clearInterval(this.intervalId);
  },

  methods: {
    editItem(item) {
      this.editedIndex = this.giveaways.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },
    copyItem(item) {
      this.editedItem = { ...item };
      delete this.editedItem.id;
      this.dialog = true;
    },
    newGiveaway() {
      this.editedIndex = -1;
      this.editedItem = {};
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
    deleteItemConfirm() {
      BackendService.deleteGiveawayNoPointsUser({
        id: this.$route.params.id,
        username: this.editedItem.username,
      }).then((data) => {
        this.giveaways = data.data;
        this.closeDelete();
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
    deleteItem(item) {
      this.editedIndex = this.giveaways.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },
    startItem(item) {
      BackendService.startGiveawayNoPoints({
        id: item.id,
        title: item.title,
      }).then((data) => {
        this.giveaways = data.data;
        this.intervalId = setInterval(() => {
          BackendService.loadGiveawaysNoPoints().then((data1) => {
            this.giveaways = data1.data;
          });
        }, 10000);
      });
    },
    stopItem(item) {
      BackendService.stopGiveawayNoPoints({
        id: item.id,
        title: item.title,
      }).then((data) => {
        clearInterval(this.intervalId);
        this.giveaways = data.data;
      });
    },
    pickWinner() {
      if (this.dialogWinner === true) this.dialogWinner = false;
      BackendService.pickWinnerGiveawayNoPoints({
        id: this.$route.params.id,
      }).then((data) => {
        clearInterval(this.intervalId);
        this.giveaways = data.data.users;
        this.winner = data.data.winner;
        this.safeWinnerItem = data.data.winner;
        this.dialogWinner = true;
      });
    },
    lastWinner() {
      if (this.dialogWatchWinner === true) this.dialogWatchWinner = false;
      BackendService.lastWinnerGiveawayNoPoints({
        id: this.$route.params.id,
      }).then((data) => {
        clearInterval(this.intervalId);
        this.winner = data.data.winner;
        this.dialogWatchWinner = true;
      });
    },
    closeGiveawayWinnerDialog() {
      this.dialogWinner = false;
    },
    closeGiveawayWatchWinnerDialog() {
      this.dialogWatchWinner = false;
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        BackendService.saveGiveawayNoPoints(
          this.editedItem,
        ).then((data) => {
          this.giveaways = data.data;
        }).catch(() => {
          alert('nö!');
        }).finally(() => {
          this.saving = false;
          this.close();
        });
      }
    },
  },
};
</script>
